import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg';

function AllInclusive(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(G, {
    clipPath: "url(#prefix__clip0_312_7)"
  }, React.createElement(Path, {
    fillRule: "evenodd",
    d: "M2.232.293A1 1 0 001.189.058C.472.314.487 1.098.499 1.741l.002.117c.009.576.06 1.38.227 2.318.334 1.87 1.14 4.307 3.044 6.482a1 1 0 001.46.05l2.293-2.294.59.59-5.896 7.371a1 1 0 001.562 1.25l5.757-7.197 1.232 1.232a7.5 7.5 0 101.485-1.344l-1.46-1.46.626-.781c1.45.559 3.243.223 4.255-1.31.417-.631.954-1.55 1.196-2.514.123-.49.208-1.139.042-1.826A3.016 3.016 0 0015.56.554c-1.453-.908-2.905-.392-3.743.119-.837.51-1.526 1.258-1.984 1.82-1.14 1.398-.934 3.177-.014 4.383l-.446.558L2.232.293zm2.38 8.205C3.401 6.79 2.871 4.965 2.65 3.538L6.111 7 4.612 8.498zM16.5 11a5.5 5.5 0 100 11 5.5 5.5 0 000-11zm-2-8.75c-1.045-.653-2.296.5-3.117 1.507-.553.678-.374 1.65.309 2.197.732.585 1.799.492 2.315-.29.768-1.164 1.534-2.764.493-3.414zm2.67 10.415a.75.75 0 00-1.34 0l-1.994 3.986a.73.73 0 00-.014.028l-.993 1.986a.75.75 0 101.342.67l.793-1.585h3.072l.793 1.585a.75.75 0 101.342-.67l-.993-1.986a.913.913 0 00-.014-.028l-1.993-3.986zm-.67 2.012l.787 1.573h-1.573l.786-1.573z",
    clipRule: "evenodd"
  })), React.createElement(Defs, null, React.createElement(ClipPath, {
    id: "prefix__clip0_312_7"
  }, React.createElement(Path, {
    d: "M0 0h24v24H0z"
  }))));
}

export default AllInclusive;